import React from "react";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";

const ZenFloatingBar = ({
  open,
  hasPrev,
  hasNext,
  onPrev,
  onNext,
  onExitZen,
  wakeLock,
  edition,
}) => {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: { xs: 16, sm: 24 },
        right: { xs: 16, sm: 24 },
        zIndex: 1280,
        display: "flex",
        alignItems: "center",
        gap: 1,
        p: 0.75,
        borderRadius: 999,
        bgcolor: (theme) =>
          theme.palette.mode === "dark"
            ? "rgba(18, 24, 24, 0.9)"
            : "rgba(255, 255, 255, 0.92)",
        backdropFilter: "blur(12px)",
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "0 6px 24px rgba(0,0,0,0.15)",
      }}
    >
      <Tooltip title={edition.ui.prevChapter} placement="top">
        <span>
          <IconButton size="small" onClick={onPrev} disabled={!hasPrev}>
            <NavigateBeforeIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      <Button
        size="small"
        variant="text"
        startIcon={<CloseFullscreenIcon sx={{ fontSize: 14 }} />}
        onClick={onExitZen}
        sx={{
          textTransform: "none",
          fontSize: "0.75rem",
          borderRadius: 999,
          px: 1.2,
          color: "text.primary",
        }}
      >
        {edition.ui.exitZenMode || "退出专注 (Esc)"}
      </Button>

      {wakeLock?.isSupported && (
        <Tooltip
          title={
            wakeLock.isEnabled
              ? wakeLock.isActive
                ? edition.ui.wakeLockActive || "屏幕常亮中 (点击关闭)"
                : edition.ui.wakeLockActive || "保持常亮 (点击关闭)"
              : edition.ui.wakeLockInactive || "屏幕常亮已关闭 (点击开启)"
          }
          placement="top"
        >
          <IconButton
            size="small"
            onClick={wakeLock.toggleEnabled}
            aria-label={
              wakeLock.isEnabled
                ? edition.ui.wakeLockActive || "关闭屏幕常亮"
                : edition.ui.wakeLockInactive || "开启屏幕常亮"
            }
            sx={{
              color: wakeLock.isActive ? "warning.main" : "text.secondary",
              p: 0.5,
            }}
          >
            {wakeLock.isActive ? (
              <LightbulbIcon sx={{ fontSize: 16 }} />
            ) : (
              <LightbulbOutlinedIcon sx={{ fontSize: 16 }} />
            )}
          </IconButton>
        </Tooltip>
      )}

      <Tooltip title={edition.ui.nextChapter} placement="top">
        <span>
          <IconButton size="small" onClick={onNext} disabled={!hasNext}>
            <NavigateNextIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default ZenFloatingBar;
